import NextHead from 'next/head'
import { FC } from 'react'

import { Maybe } from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useTranslation } from '@/core'

type HeadProps = {
  title:
    | (string | Maybe<string> | undefined)
    | (string | Maybe<string> | undefined)[]
  description?: string
  ogImage?: string
}

export const Head: FC<HeadProps> = ({
  title,
  description,
  ogImage,
  children,
}) => {
  const { t } = useTranslation()
  const commonTitle = t('metaTitle')

  const titleValue = title
    ? `${
        Array.isArray(title) ? title.filter(_ => _).join(' | ') : title
      } | ${commonTitle}`
    : commonTitle

  const descriptionValue = description ?? t('metaDescription')
  /**
   * @todo
   * itemDetailとcollectionDetailはOGP画像を動的生成する。API実装後対応する
   * https://app.clickup.com/t/908127/UT-5146
   */
  const ogImageValue = ogImage ?? config.meta.ogImage

  return (
    <NextHead>
      <title>{titleValue}</title>
      <meta content={titleValue} property="og:title" />
      <meta content={descriptionValue} name="description" />
      <meta content={descriptionValue} property="og:description" />
      <meta content={descriptionValue} property="twitter:decription" />
      <meta content={ogImageValue} property="og:image" />
      <meta content={ogImageValue} property="twitter:image" />
      {children}
    </NextHead>
  )
}
